import * as actionTypes from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

/**
 * @param {boolean} _
 * @param {boolean} checked
 * @returns {boolean}
 */
const set = (_, { payload: checked }) => checked;

/** @return {boolean} */
const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.SET_SHOW_IMPORTED_WORK]: set,
  [actionTypes.CLOSE_WORK_ORDER_MODAL]: reset,
});
